import { initDataSetOrder } from '@/utils/modules/payment'
import { getUserCashier } from '@/utils/helper/localStorage'
import OrderProvider from '@/resources/order_provider'
import MemberOrderProvider from '@/resources/member_order_history'
const orderProvider = new OrderProvider()
const memberOrderProvider = new MemberOrderProvider()

const state = {
  type: '',
  change: '',
  receivedMoney: {
    receivedCash: '',
    receivedCard: ''
  },
  memberOrderHistory: {},
  total: '',
  order: {},
  time: ''
}

const actions = {
  async setOrder ({commit, getters, state}, payload) {
    console.log(payload)
    commit('SET_TOTAL')
    const params = initDataSetOrder(payload, state, getters.getTel, getters.billExpire)
    const promoCode = getters.getPromotionCode
    const cashier = getUserCashier()

    const order = await orderProvider.posCompleteCart(params, promoCode, getters.getTel)
    const { data } = await memberOrderProvider.createOrderHistory({
      order: order,
      tel: getters.getTel,
      items: getters.getItems,
      promotionCode: getters.getPromotionCode,
      cashier: cashier
    })
    console.log(data)
    commit('SET_ORDER', order)
    commit('SET_MEMBER_ORDER_HISTORY', data)

    return data
  },
  calculatedChange ({commit}, payload) {
    commit('CALCULATED_CHANGE', payload)
  },
  setChange ({commit}, payload) {
    commit('SET_CHANGE', payload)
  },
  setReceivedCash ({commit}, payload) {
    commit('SET_RECEIVE_CASH', payload)
  },
  clearMoney ({commit}) {
    commit('CLEAR_MONEY')
  },
  async checkout ({ dispatch, getters, commit }, channel) {
    if (channel === 'Credit') {
      commit('SET_RECEIVED_CARD', getters.getNetPrice)
      commit('SET_RECEIVE_CASH', 0)
      commit('SET_CHANGE', 0)
    } else {
      commit('SET_RECEIVED_CARD', 0)
    }
    const paymentChannels = getters.paymentChannel
    const paymentChannelIndex = paymentChannels.findIndex(type => type.payment_name === channel)
    const payPal = paymentChannels.find(type => type.payment_name === 'Paypal')
    if (paymentChannelIndex === -1) {
      await commit('SET_TYPE', payPal)
    } else {
      await commit('SET_TYPE', paymentChannels[paymentChannelIndex])
    }
    await commit('SET_TIME', new Date())
    await dispatch('setOrder', {items: getters.getItems, price: getters.getNetPrice})
  }
}

const mutations = {
  SET_TYPE: (state, payload) => {
    state.type = payload
  },
  SET_ORDER: (state, payload) => {
    state.order = payload
  },
  CALCULATED_CHANGE: (state, payload) => {
    state.receivedMoney.receivedCash = payload.receive
    state.change = state.receivedMoney.receivedCash - payload.netPrice
  },
  SET_MEMBER_ORDER_HISTORY: (state, payload) => {
    state.memberOrderHistory = payload
  },
  SET_CHANGE: (state, payload) => {
    state.change = payload
  },
  SET_RECEIVED_CARD: (state, payload) => {
    state.receivedMoney.receivedCard = payload
  },
  SET_RECEIVE_CASH: (state, payload) => {
    state.receivedMoney.receivedCash = payload
  },
  CLEAR_MONEY: (state) => {
    state.receivedMoney.receivedCard = 0
    state.receivedMoney.receivedCash = 0
    state.change = 0
  },
  SET_TIME: (state, payload) => {
    state.time = payload
  },
  SET_TOTAL: (state) => {
    state.total = state.receivedMoney.receivedCash + state.receivedMoney.receivedCard
  }
}

const getters = {
  getChange: (state) => {
    return state.change
  },
  getReceivedCash: (state) => {
    return state.receivedMoney.receivedCash
  },
  getMemberOrderHistory: (state) => {
    return state.memberOrderHistory
  },
  getReceivedCard: (state) => {
    return state.receivedMoney.receivedCard
  },
  getOrder: (state) => {
    return state.order
  },
  getBillID: (state) => {
    return (Object.keys(state.order).length === 0) ? '' : state.order.bill.id
  },
  getTime: (state) => {
    return state.time
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/modules/payment.js